export default "__VITE_ASSET__CAOMHyu4__"